
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
    apiKey: "AIzaSyCd-vCnDJXtjsqoFIy525DCEGg7tbvguCM",
    authDomain: "winners-ai-473119.firebaseapp.com",
    projectId: "winners-ai-473119",
    storageBucket: "winners-ai-473119.firebasestorage.app",
    messagingSenderId: "712108985873",
    appId: "1:712108985873:web:944314ab73cc9a42422bb0",
    measurementId: "G-ZRWZPQLQZN"
};

const firebaseApp = initializeApp(firebaseConfig);

const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);


const apimaker = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJncHRtYWtlciIsImlkIjoiM0REODM1NkZDQzgyNTEwRkMxNTk4MjRCMjM3NjIwN0YiLCJ0ZW5hbnQiOiIzREQ4MzU2RkNDODI1MTBGQzE1OTgyNEIyMzc2MjA3RiIsInV1aWQiOiI3NDliMDJmOC1jNjFhLTQ1MDEtYmVhMy03OGVlNzZjN2IyOGUifQ.lwfSYq8GJbBwDsPpvCmqJN9siUEXJ2lELggyTNACFLA';

export { auth, db, apimaker };